import { FunctionIcon } from "../../../icons/FunctionIcon";
import type { MenuConfig } from "../../types";
import { any, none, anyColumn, column, featureDisabled, selection } from "../../disabled-helpers";
import { showFormula } from "../../../actions";

export const showFormulaSection: MenuConfig[] = [
  {
    id: "show-formula",
    label: "Show formula",
    icon: <FunctionIcon />,
    disabled: any(selection.isMultiColumn, none(anyColumn(column.hasFormula)), featureDisabled("showFormula")),
    action: (ctx) => () => showFormula(ctx),
  },
];
